import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import OrgDocumentsTab from '../../components/org-documents/OrgDocumentsTab';
import { portalOrgDocumentApi } from '../../components/org-documents/orgDocumentApi';
import ApiService from '../../services/api.service';

const loadOrganizationTypes = async () => {
  const resp = await ApiService.getPortalTcDocumentTypes('ORGANIZATION');
  return resp?.data?.data || [];
};

/** The client's own company documents (trade licence, establishment card, ...): view for everyone, upload for admins. */
const PortalCompanyDocuments = ({ portalUser }) => {
  const api = useMemo(() => portalOrgDocumentApi(), []);
  return (
    <Box sx={{ width: 0, minWidth: '100%' }}>
      <OrgDocumentsTab
        api={api}
        loadTypes={loadOrganizationTypes}
        canWrite={portalUser?.role === 'ORG_ADMIN'}
        canDelete={false}
      />
    </Box>
  );
};

export default PortalCompanyDocuments;
